module.exports = __webpack_public_path__ + "img/award.c4dd02db.svg";